import { ImageBackground as ImageBackgroundLib, ImageBackgroundProps } from 'react-native';

export const ImageBackground = ({ source, ...props }: ImageBackgroundProps) => {
	return <ImageBackgroundLib source={source} {...props} />;
};
